
import React, { useState, useContext } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import AuthContainer from "../../containers/Auth";
import AuthInputText from "../../components/AuthInput";
import { useNavigate } from "react-router-dom";
import { ApiService } from '../../service/api.service';
import { AUTH_URL } from '../../common/common';
import { validationSchema } from "../../service/validation/forgotPassword";
import { TokenContext } from '../../service/context/tokencontent';

const ConfirmPassword = () => {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const entityId = localStorage.getItem("entity_id");
  const { setToken } = useContext(TokenContext) || { setToken: () => { } };

  const apiService = new ApiService();

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    watch,
  } = useForm({
    defaultValues: {
      newPassword: "",
      confirmPassword: "",
    },
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = async (data: { newPassword: string; confirmPassword: string }) => {
    try {
      if (!entityId) {
        setError("Entity ID is missing. Please try again.");
        return;
      }

      const payload = {
        entityId,
        newPassword: data.newPassword,
        confirmPassword: data.confirmPassword,
      };

      let response: any = await apiService.postApi(`${AUTH_URL}/new-password-route`, payload);

      if (response.status === "200") {
        localStorage.setItem("user_data_motsop", JSON.stringify(response.body.data));
        const tokenValue = response.body.authToken;
        if (tokenValue) {
          localStorage.setItem("motosop", tokenValue);
          setToken(tokenValue);
        }
        if (response.body.data) {
          const { entityid, userId } = response.body.data;
          if (entityid) localStorage.setItem("entity_id", entityid);
          if (userId) localStorage.setItem("userId", userId);
        }
        navigate('/dashboard');
      } else {
        setError(response.message || "Failed to reset password. Please try again.");
      }
    } catch (err: any) {
      setError(err?.message || "Something went wrong. Please try again.");
      console.error('Password Reset Error:', err);
    }
  };

  return (
    <AuthContainer>
      <div className="flex w-full rounded-[21.25px] h-full bg-white font-poppins">
        <div className="w-full h-full">
          <div className="md:mx-[4rem] my-[2rem] m-6">
            <div className="h-[100px] w-[239px] bg-[#D9D9D9] flex items-center justify-center">
              logo
            </div>
            <br />
            <p className="font-[700] text-[20px] font-poppins track-[1%]">
              Reset Your Password
            </p>
            <p className="font-[400] text-[16px] text-[#313957]">
              Create a new password for your Smart Fleet Management account
            </p>
            <br />

            {error && (
              <div className="mb-4 p-3 bg-red-100 text-red-700 rounded">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit(onSubmit)}>
              <AuthInputText
                label="New Password"
                value={watch("newPassword")}
                errors={errors}
                placeholder="Enter your new password"
                autoComplete="new-password"
                name="newPassword"
                type="password"
                register={register}
              />
              <AuthInputText
                label="Confirm Password"
                value={watch("confirmPassword")}
                errors={errors}
                placeholder="Confirm your new password"
                autoComplete="new-password"
                name="confirmPassword"
                type="password"
                register={register}
              />

              <div className="mx-6">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`mt-4 p-2 w-full h-[50px] text-[16px] bg-[#444FBD] rounded-[20px] text-white ${isSubmitting ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                >
                  {isSubmitting ? "Submitting..." : "Reset Password"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </AuthContainer>
  );
};

export default ConfirmPassword;